import {
  ADDRESS,
  CANTON,
  CITY,
  FIELDS,
  IS_REFERRAL_PARTNER,
  KIND,
  NAME,
  OPHTHALMOLOGY,
  ORGANIZATION_KINDS,
  SERVICES,
  SPECIALTY,
  ZIP_CODE,
} from 'store/organizations';

export const DEFAULT_PARAMS = {
  [FIELDS]: [NAME, ADDRESS, ZIP_CODE, CITY, CANTON, SERVICES],
  [KIND]: ORGANIZATION_KINDS.CLINIC,
  [SPECIALTY]: OPHTHALMOLOGY,
  [IS_REFERRAL_PARTNER]: true,
};
